import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';
import { NotificationCard } from '../../components/notificationCard/notificationCard';
import { LinkType } from '../../state/reduxRepositories/notifications/notification.interfaces';
import { di } from '../../state/inversify.config';
import { getInitials } from '../../helpers/initialsExtractor';
import { getPlayerDetails } from '../conneqt/conneqt.helper';
import { ConneqtRepository } from '../../state/reduxRepositories';
import { Pages } from '../../state/queryParams/pageQueries.slice';
import { ConneqtSubRoutes } from '../conneqt/conneqtSubRoutes';
import { AccountTypes } from '../../components/changeUser/accountTypes.enum';

// import { PlayersPageQueryService } from './playersPage.queryParam.service';

interface Notification {
  id: string;
  mainText: string;
  notificationTime: Date;
  linkType: LinkType;
  linkId: string;
  read: boolean;
}

interface NotificationListProps {
  notifications: Notification[];
  setAsRead: (notificationId: string) => void;
}

export function NotificationList({
  notifications,
  setAsRead,
}: NotificationListProps): JSX.Element {
  // const playersPageQueryService = di.get<PlayersPageQueryService>(
  //   PlayersPageQueryService,
  // );

  const conneqtRepository = di.get<ConneqtRepository>(ConneqtRepository);
  const { t } = useTranslation();

  const selectNotification = (notification: Notification) => {
    // playersPageQueryService.dispatchQueryParams({
    //   selectedPlayerId: player.id,
    // });
  };

  const accountType = useLocation().pathname.split('/')[1];
  const navigator = useNavigate();

  const createLinkText = (notification: Notification) => {
    if (notification.linkType === LinkType.conneqt) {
      return t('notification.NOTIFICATION_CLICK_TO_VIEW_CONNEQT_REQUEST');
    }
    if (notification.linkType === LinkType.incident) {
      return t('notification.NOTIFICATION_CLICK_TO_VIEW_INCIDENT_REPORT');
    }
    if (notification.linkType === LinkType.player) {
      return t('notification.NOTIFICATION_CLICK_TO_VIEW_PLAYER_PROFILE');
    }
    return t('notification.NOTIFICATION_CLICK_TO_MARK_AS_READ');
  };

  const getNotificationInitials = (notification: Notification) => {
    if (notification.linkType === LinkType.conneqt) {
      const conneqt = conneqtRepository.getResource(notification.linkId);
      if (conneqt)
        return getInitials(getPlayerDetails(conneqt.requestPlayerClues)?.name);
    }
    return '🔔'; // return 'No';
  };

  const handleClick = (notification: Notification) => {
    setAsRead(notification.id);

    if (notification.linkType === LinkType.conneqt) {
      if (accountType === AccountTypes.Guardian) {
        navigator(
          `/${accountType}/${Pages.conneqt}/${ConneqtSubRoutes.received}?selectedConneqtId=${notification.linkId}`,
        );
      } else {
        navigator(
          `/${accountType}/${Pages.conneqt}/${ConneqtSubRoutes.sent}?selectedConneqtId=${notification.linkId}`,
        );
      }
    } else if (notification.linkType === LinkType.player) {
      navigator(
        `/${accountType}/player-profile?selectedPlayerId=${notification.linkId}`,
      );
    }
  };

  return (
    <Container>
      {notifications
        .sort((a, b) => {
          if (a.notificationTime > b.notificationTime) return -1;
          if (a.notificationTime < b.notificationTime) return 1;
          return 0;
        })
        // .sort((a, b) => Number(a.clearedToPlay) - Number(b.clearedToPlay))
        .map((notificationItem) => {
          return (
            <Box
              // onClick={() => selectNotification(notificationItem)}
              key={notificationItem.id}
            >
              <NotificationCard
                testId="newNotification"
                initials={getNotificationInitials(notificationItem)}
                mainText={notificationItem.mainText}
                notificationTime={notificationItem.notificationTime}
                linkType={LinkType.conneqt}
                linkId="1234"
                linkText={createLinkText(notificationItem)}
                read={notificationItem.read}
                onClick={() => {
                  handleClick(notificationItem);
                }}
              />
            </Box>
          );
        })}
    </Container>
  );
}
